var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "expense-list-entry" }, [
    _c(
      "div",
      {
        on: {
          click: function($event) {
            _vm.$router.push({
              name: "expense",
              params: { expenseId: _vm.expense.id }
            })
          }
        }
      },
      [
        _c("div", [
          _c("span", { staticClass: "expense-list-entry__amount" }, [
            _vm._v(_vm._s(_vm.amountHumanReadable))
          ]),
          _vm.hasSupplier
            ? _c("span", { staticClass: "expense-list-entry__supplier-name" }, [
                _vm._v("\n         / " + _vm._s(_vm.supplierName) + "\n      ")
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "expense-list-entry__invoice-date" },
          [
            _c("q-icon", {
              attrs: { name: "calendar_today", color: "grey-6" }
            }),
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("invoice_date")) +
                  " " +
                  _vm._s(_vm.invoiceDateHumanReadable)
              )
            ])
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      {
        on: {
          click: function($event) {
            _vm.$router.push({
              name: "expense",
              params: { expenseId: _vm.expense.id }
            })
          }
        }
      },
      [
        _c("div", { staticClass: "expense-list-entry__payment" }, [
          _c("div", [
            _vm.hasDueDate
              ? _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("expense_due_to", {
                        date: _vm.dueDateHumanReadable
                      })
                    )
                  )
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("expense_no_due_date")))])
          ]),
          _vm.isPaid
            ? _c(
                "div",
                [
                  _c("q-icon", {
                    staticClass: "bg-green-4 circle",
                    staticStyle: { padding: "1px" },
                    attrs: { name: "check", color: "white", size: "12px" }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("expense_paid_at_line", {
                          date: _vm.paymentDateHumanReadable
                        })
                      ) +
                      "\n      "
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("q-icon", {
                    staticClass: "bg-red-4 circle",
                    staticStyle: { padding: "1px" },
                    attrs: { name: "clear", color: "white", size: "12px" }
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("expense_not_yet_paid")) + "\n      "
                  )
                ],
                1
              )
        ])
      ]
    ),
    _c(
      "div",
      [
        _vm.isCommitted
          ? _c(
              "q-chip",
              {
                staticClass: "gt-sm",
                attrs: {
                  dense: "",
                  color: "positive",
                  "text-color": "white",
                  icon: "lock"
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("committed")) + "\n    ")]
            )
          : _vm._e(),
        _c("q-icon", {
          staticClass: "lt-md text-grey-8",
          attrs: { name: "lock" }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "expense-list-entry__action-btn" },
      [
        _c(
          "q-btn",
          {
            attrs: {
              icon: "more_vert",
              color: "grey-7",
              flat: "",
              round: "",
              dense: ""
            }
          },
          [
            _c(
              "q-popover",
              [
                _c(
                  "q-list",
                  { staticClass: "no-border", attrs: { link: "" } },
                  [
                    _c(
                      "q-item",
                      {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        nativeOn: {
                          click: function($event) {
                            return _vm.handleDownload($event)
                          }
                        }
                      },
                      [
                        _c("q-item-side", {
                          attrs: { icon: "cloud_download" }
                        }),
                        _c("q-item-main", {
                          attrs: { label: _vm.$t("download") }
                        })
                      ],
                      1
                    ),
                    !_vm.isCommitted
                      ? _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            nativeOn: {
                              click: function($event) {
                                return _vm.handleCommit($event)
                              }
                            }
                          },
                          [
                            _c("q-item-side", { attrs: { icon: "lock" } }),
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("commit") }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isCommitted
                      ? _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            nativeOn: {
                              click: function($event) {
                                return _vm.handleDelete($event)
                              }
                            }
                          },
                          [
                            _c("q-item-side", { attrs: { icon: "delete" } }),
                            _c("q-item-main", {
                              attrs: { label: _vm.$t("delete") }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "expense-list-entry__view-btn" },
      [
        _c("q-btn", {
          staticClass: "q-pa-xs",
          attrs: {
            to: {
              name: "expense",
              params: { expenseId: this.expense.id, teamId: _vm.activeTeam.id }
            },
            icon: "chevron_right",
            color: "grey-8",
            flat: ""
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }